import React, { useState } from "react";
import { DataProvider } from '../../../../../../../components/Integration/DataConnections/DataProvider';
import DataConnectPage from './DataConnectPage';
import McpToolsPage from './McpToolsPage';
import InboundMcpToolsPage from './InboundMcpToolsPage';
import { Tab } from "semantic-ui-react";

const DataConnect = (props) => {
  const isOutbound = props.bot_type === "OUTBOUND";
  const isInbound = props.bot_type === "Voice_Turbo";

  // Voice_Turbo (inbound): Function Tools + Inbound MCP Tools
  if (isInbound) {
    const panes = [
      {
        menuItem: 'Function Tools',
        render: () => (
          <Tab.Pane>
            <DataProvider>
              <DataConnectPage
                workspace_id={props.workspace_id}
              />
            </DataProvider>
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'MCP Tools',
        render: () => (
          <Tab.Pane>
            <InboundMcpToolsPage
              workspace_id={props.workspace_id}
            />
          </Tab.Pane>
        ),
      },
    ];

    return <Tab panes={panes} />;
  }

  // OUTBOUND: Function Tools + Outbound MCP Tools
  if (isOutbound) {
    const panes = [
      {
        menuItem: 'Function Tools',
        render: () => (
          <Tab.Pane>
            <DataProvider>
              <DataConnectPage
                workspace_id={props.workspace_id}
              />
            </DataProvider>
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'MCP Tools',
        render: () => (
          <Tab.Pane>
            <McpToolsPage
              workspace_id={props.workspace_id}
            />
          </Tab.Pane>
        ),
      },
    ];

    return <Tab panes={panes} />;
  }

  // All other types (Voice_Turbo, etc.): Function Tools only
  return (
    <DataProvider>
      <DataConnectPage
        workspace_id={props.workspace_id}
      />
    </DataProvider>
  );
};

export default DataConnect;
